import { render, staticRenderFns } from "./CampaignListItem.vue?vue&type=template&id=a1650e92&scoped=true&"
import script from "./CampaignListItem.vue?vue&type=script&lang=ts&"
export * from "./CampaignListItem.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignListItem.vue?vue&type=style&index=0&id=a1650e92&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1650e92",
  null
  
)

export default component.exports